import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Wifi } from 'lucide-react';
import { companyInfo } from '../mock';

const Footer = () => {
  return (
    <footer className="bg-[#050505] text-white border-t border-white/10 relative overflow-hidden" data-testid="site-footer">
      <div className="ambient-glow opacity-40" />
      <div className="container mx-auto px-4 py-14 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Company Info */}
          <div className="space-y-4">
            <img
              src="https://customer-assets.emergentagent.com/job_webfiber/artifacts/zrtdvt1j_full_trimmed_transparent_customcolor.png"
              alt="SSM VISION Logo"
              className="h-14 w-auto drop-shadow-[0_0_14px_rgba(255,140,0,0.5)]"
            />
            <p className="text-white/60 text-sm">{companyInfo.tagline}</p>
            <div className="flex items-center gap-2 text-[#FFB347]">
              <Wifi className="w-5 h-5" />
              <span className="font-semibold">High Speed Broadband</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-white/60 hover:text-[#FFB347] transition-colors">Home</Link></li>
              <li><Link to="/plans" className="text-white/60 hover:text-[#FFB347] transition-colors">All Plans</Link></li>
              <li><Link to="/contact" className="text-white/60 hover:text-[#FFB347] transition-colors">Contact Us</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Services</h3>
            <ul className="space-y-2 text-white/60">
              <li>WiFi Broadband</li>
              <li>Cable TV Packages</li>
              <li>OTT Platforms</li>
              <li>Combo Offers</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <Phone className="w-5 h-5 text-[#FFB347] mt-0.5 flex-shrink-0" />
                <a href={`tel:${companyInfo.phone}`} className="text-white/60 hover:text-[#FFB347] transition-colors">
                  {companyInfo.phone}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-[#FFB347] mt-0.5 flex-shrink-0" />
                <a href={`mailto:${companyInfo.email}`} className="text-white/60 hover:text-[#FFB347] transition-colors">
                  {companyInfo.email}
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#FFB347] mt-0.5 flex-shrink-0" />
                <span className="text-white/60">{companyInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 pt-6 text-center">
          <p className="text-white/50 text-sm">
            © {new Date().getFullYear()} {companyInfo.name}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
